import { actions } from 'api/actions';
import { endpoints } from 'api/endpoints';
import { EntryMode, isExistingSiteEntryMode } from 'config/entry-mode';
import { useAppStore } from 'stores/appStore';

type SequentialTask = {
  task: () => Promise<void>;
  retries?: number;
};

type SequentialTaskGroup = SequentialTask | SequentialTask[];

export function getStoreSetupTaskGroups(entryMode: EntryMode): SequentialTaskGroup[] {
  if (isExistingSiteEntryMode(entryMode)) {
    return getExistingSiteStoreSetupTaskGroups();
  }

  return getNetNewStoreSetupTaskGroups();
}

function getNetNewStoreSetupTaskGroups(): SequentialTaskGroup[] {
  return [
    [
      { task: actions.attachSiteTemplate },
      {
        task: async () => {
          await endpoints.deleteAllProducts();
        },
      },
      { task: actions.uploadSiteMedia },
    ],
    [{ task: actions.addStoreProducts }, { task: actions.updateSiteName }, { task: actions.injectSiteNameComponent }],
    {
      task: async () => {
        await endpoints.publishSite();
      },
    },
    [
      { task: actions.validateCatalogProductsCount, retries: 20 },
      { task: actions.fetchSiteUrl, retries: 10 },
    ],
  ];
}

function getExistingSiteStoreSetupTaskGroups(): SequentialTaskGroup[] {
  return [
    [{ task: actions.prepareExistingSiteStore }, { task: actions.uploadSiteMedia }],
    [{ task: actions.addStoreProducts }],
  ];
}

export function resolveStoreSetupEntryMode(): EntryMode {
  return useAppStore.getState().entryMode;
}
